<template>
  <v-container>
    <v-row class="mb-n6">
      <v-col>
        <p>{{ kind.listTitle }}</p>
      </v-col>
      <v-col class="text-right">
        <v-btn
          color="primary"
          @click="$router.push({ name: kind.createRoute })"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          {{ kind.createButton }}
        </v-btn>
      </v-col>
    </v-row>

    <v-card class="mt-6">
      <v-card-title>
        <v-text-field
          v-model="filter"
          append-icon="mdi-magnify"
          label="ຄົ້ນຫາ ຊື່ ຫຼື ເບີໂທ"
          single-line
          hide-details
          clearable
          @keyup.enter="fetchData(1)"
          @click:clear="filter = ''; fetchData(1)"
        />
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="items"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            :color="item.status === 'rejected' ? 'error' : 'warning'"
            label
            small
          >
            {{ item.status === 'rejected' ? 'ຖືກປະຕິເສດ' : 'ລໍຖ້າອະນຸມັດ' }}
          </v-chip>
        </template>
        <template v-slot:[`item.home_customer`]="{ item }">
          {{ homeLabel(item.home_customer) }}
        </template>
        <template v-slot:[`item.reject_reason`]="{ item }">
          <span class="error--text">{{ item.reject_reason }}</span>
        </template>
        <template v-slot:[`item.action`]="{ item }">
          <v-btn
            small
            text
            color="primary"
            @click="$router.push({ name: kind.editRoute, params: { id: item.id } })"
          >
            <v-icon
              small
              left
            >
              mdi-pencil
            </v-icon>
            {{ item.status === 'rejected' ? 'ແກ້ໄຂ ແລະ ສົ່ງໃໝ່' : 'ແກ້ໄຂ' }}
          </v-btn>
        </template>
      </v-data-table>
      <Pagination
        v-if="pagination.total_pages > 1"
        :pagination="pagination"
        :offset="offset"
        @paginate="fetchData()"
      />
    </v-card>
  </v-container>
</template>

<script>
import { submissionKind, homeLabel } from './submissionKinds';

export default {
  title() {
    return 'Vientiane Waste Co-Dev|Company Submission';
  },
  data() {
    return {
      items: [],
      filter: '',
      offset: 12,
      pagination: {},
      requestSeq: 0,
    };
  },
  computed: {
    kind() {
      return submissionKind(this.$route);
    },
    headers() {
      return [
        ...(this.kind.isConversion ? [{ text: 'ສາຍບ້ານທີ່ປິດ', value: 'home_customer', sortable: false }] : []),
        { text: 'ຊື່ບໍລິສັດ', value: 'company_name' },
        { text: 'ເບີໂທ', value: 'phone' },
        { text: 'ສະຖານະ', value: 'status' },
        { text: 'ເຫດຜົນທີ່ປະຕິເສດ', value: 'reject_reason', sortable: false },
        { text: 'ວັນທີເພີ່ມ', value: 'created_at' },
        { text: '', value: 'action', sortable: false },
      ];
    },
  },
  watch: {
    // Same component for the new-company and conversion routes: reload when switching.
    '$route.name': function () {
      this.items = [];
      this.filter = '';
      this.pagination = {};
      this.fetchData(1);
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    homeLabel,
    fetchData(page) {
      // Ignore responses to superseded searches (the API can be slow).
      const seq = ++this.requestSeq;
      if (page) this.$set(this.pagination, 'current_page', page);
      this.$store.commit('Loading_State', true);
      this.$axios
        .get(this.kind.api, {
          params: {
            page: this.pagination.current_page,
            per_page: 20,
            filter: this.filter || undefined,
          },
        })
        .then((res) => {
          if (seq !== this.requestSeq) return;
          this.items = res.data.data.data;
          this.pagination = res.data.data.pagination;
        })
        .finally(() => {
          this.$store.commit('Loading_State', false);
        });
    },
  },
};
</script>
